import { ComponentProps, lazy, LazyExoticComponent, Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import type DesktopDatePicker from './DesktopDatePicker';
import MobileDateField from './MobileDateField';

const DesktopDatePickerLazy = lazy(
  () => import('./DesktopDatePicker'),
) satisfies LazyExoticComponent<typeof DesktopDatePicker>;

type Props = ComponentProps<typeof DesktopDatePickerLazy>;
const DesktopDateField = (props: Props) => (
  <ErrorBoundary fallback={<MobileDateField {...props} />}>
    <Suspense fallback={<MobileDateField {...props} />}>
      <DesktopDatePickerLazy {...props} />
    </Suspense>
  </ErrorBoundary>
);

export default DesktopDateField;
